import { Skeleton, TypographyProps } from '@mui/material'
import { AppTypography } from 'components/base'
import { FC } from 'react'

interface Props extends TypographyProps {
  isLoading?: boolean
  ip?: string
}

export const IpText: FC<Props> = ({ isLoading, ip, ...props }) => {
  const handleClick = () => {
    if (ip) {
      window.open(`https://ipinfo.io/${ip}`, '_blank')
      window.open('https://www.ipvoid.com/ip-to-google-maps/', '_blank')
    }
  }
  return (
    <>
      {isLoading ? (
        <Skeleton variant="text" height={15} width={40} />
      ) : (
        <AppTypography {...props} component={'a'} onClick={handleClick} isColorPrimary>
          {ip ?? ''}
        </AppTypography>
      )}
    </>
  )
}
